document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.fp-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var answer = this.nextElementSibling;
      var isOpen = answer.classList.contains('open');
      document.querySelectorAll('.fp-faq-a').forEach(function(a) {
        a.classList.remove('open');
      });
      document.querySelectorAll('.fp-faq-q').forEach(function(b) {
        b.classList.remove('open');
      });
      if (!isOpen) {
        answer.classList.add('open');
        btn.classList.add('open');
      }
    });
  });
});
